// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入接口
import serverUrl from './js/server-config.js';
// 引入echarts
import * as echarts from 'echarts';
import Ajax from '@/js/ajax.js'
// 全局过滤器
import * as filters from './js/filters.js';
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])//插入过滤器名和对应方法
})

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.Ajax = Ajax
// 全局api
window.API = serverUrl;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js